// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foosS3 {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--spacing-3);
}

.rr2mv6 {
  height: 72px;
  width: 72px;
}

.yAJh5Y {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  text-align: center;
}

.Qgxwb3 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: center;
  width: auto;
  max-width: 270px;
}

.f7mHlX {
  height: 40px;
  min-width: 166px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ExtractNoResultError/ExtractNoResultError.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".noResultWrapper {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.noResultImage {\n  height: 72px;\n  width: 72px;\n}\n\n.noResultTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  text-align: center;\n}\n\n.noResultCaption {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: center;\n  width: auto;\n  max-width: 270px;\n}\n\n.actionButton {\n  height: 40px;\n  min-width: 166px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noResultWrapper": `foosS3`,
	"noResultImage": `rr2mv6`,
	"noResultTitle": `yAJh5Y`,
	"noResultCaption": `Qgxwb3`,
	"actionButton": `f7mHlX`
};
module.exports = ___CSS_LOADER_EXPORT___;
